import React from 'react';
import ConfluencePage from '../ConfluencePage/ConfluencePage';
import { TRAINING } from '../../constants/confluenceConstants';
import '../../css/confluence.css';

const Training = () => {
  return (
    <ConfluencePage pageName={TRAINING} />
  );
};

export default Training;
